export {default} from './PeopleExtendedData';
